module.exports = __webpack_public_path__ + "img/users.e4f5dde9.svg";